import { defineComponent, openBlock, createElementBlock, createVNode, unref, withCtx, createTextVNode } from "vue";
import { CdrText, CdrLink } from "@rei/cedar";
const _hoisted_1 = {
  class: "mem-ret-modal",
  "data-ui": "mem-ret-modal-details"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "RetentionBillboardModal",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createVNode(unref(CdrText), {
        tag: "h3",
        class: "mem-ret-modal__heading"
      }, {
        default: withCtx(() => _cache[0] || (_cache[0] = [createTextVNode(" The annual Co-op Member Reward ")])),
        _: 1,
        __: [0]
      }), createVNode(unref(CdrText), {
        tag: "p"
      }, {
        default: withCtx(() => _cache[1] || (_cache[1] = [createTextVNode(" The Co-op Member Reward is an annual reward that typically gives members 10% back annually on eligible purchases. A 10% reward is typical but not guaranteed. Your Co-op Member Reward is based on eligible net qualified purchases, which exclude REI Outlet items, sale, clearance items, discounted items, gift cards, REI adventure travel, REI classes or day trips, service fees (e.g., rentals, labor), membership fee, postage, event tickets, passes or registrations, government agencies and sales tax. Notices go out in March to active REI Co-op Members who earned a Co-op Member Reward on eligible purchases during the previous year. For example, the Co-op Member Reward you earn on purchases made in 2021 will be issued in March 2022 and expire in January 2024. ")])),
        _: 1,
        __: [1]
      }), createVNode(unref(CdrText), {
        tag: "h3",
        class: "mem-ret-modal__heading"
      }, {
        default: withCtx(() => _cache[2] || (_cache[2] = [createTextVNode(" Members get 1 full year for returns ")])),
        _: 1,
        __: [2]
      }), createVNode(unref(CdrText), {
        tag: "p"
      }, {
        default: withCtx(() => [_cache[4] || (_cache[4] = createTextVNode(" We stand behind everything we sell. If you are not satisfied with your purchase, you can return it for a replacement or refund— ")), createVNode(unref(CdrLink), {
          href: "https://www.rei.com/help/returns#return-policy-exceptions"
        }, {
          default: withCtx(() => _cache[3] || (_cache[3] = [createTextVNode(" with a few exceptions ")])),
          _: 1,
          __: [3]
        }), _cache[5] || (_cache[5] = createTextVNode(" —within 365 days of the purchase date if you are an REI Co-op Member or within 90 days of the purchase if you are not a member. "))]),
        _: 1,
        __: [4, 5]
      }), createVNode(unref(CdrLink), {
        class: "mem-ret-modal__link",
        href: "https://www.rei.com/help/returns"
      }, {
        default: withCtx(() => _cache[6] || (_cache[6] = [createTextVNode(" See our full return policy for details and exclusions ")])),
        _: 1,
        __: [6]
      }), createVNode(unref(CdrText), null, {
        default: withCtx(() => _cache[7] || (_cache[7] = [createTextVNode(" Need help on anything else? Call 1-800-426-4840 ")])),
        _: 1,
        __: [7]
      })]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=RetentionBillboardModal2.mjs.map
